import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserService } from '~services/user.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac-fctv',
  styleUrls: ['./lmo-frac-fctv.component.scss'],
  templateUrl: './lmo-frac-fctv.component.html',
})
export class LmoFracFctvComponent implements OnInit {
  public navLinks: { path: string | string[]; label: string; featureFlag?: string }[] = this.userService.isAdmin()
    ? [
        { path: ['add'], label: 'Add' },
        { path: ['manage'], label: 'Manage' },
        { path: ['overflow_vendors'], label: 'Overflow Vendors' },
      ]
    : [{ path: ['overflow_vendors'], label: 'Overflow Vendors' }];

  public trackByLabel(_index: number, nav: { path: string | string[]; label: string; featureFlag?: string }): string {
    return nav.label;
  }

  constructor(private cd: ChangeDetectorRef, private userService: UserService) {}

  public ngOnInit() {
    // Makes sure that the correct tab is highlighted, since we are using onPush change detection strategy
    Promise.resolve().then(() => {
      this.cd.markForCheck();
    });
  }
}
